import type { JSX } from "solid-js";
import { pieceDef, type PieceTypeId, type PlayerId } from "../../core";
import { hideTooltip, moveTooltip, showTooltip } from "../../app/tooltip";

/**
 * Renders a chess piece using the cburnett SVG set (the classic Lichess
 * pieces), served from /public/pieces. Player 0 uses the white pieces, player 1
 * the black. The Hill is neutral terrain (one icon). Hovering any piece with a
 * mouse shows a tooltip explaining what it does. See public/pieces/ATTRIBUTION
 * for licensing.
 */
export function PieceIcon(props: {
  type: PieceTypeId;
  owner?: PlayerId;
  class?: string;
  exposed?: boolean;
  draggable?: boolean;
  dragging?: boolean;
  style?: JSX.CSSProperties;
  onPointerDown?: (e: PointerEvent) => void;
}) {
  const src = () => {
    // Terrain is neutral — one icon regardless of owner.
    if (props.type === "hill" || props.type === "valley" || props.type === "ridge") {
      return `/pieces/${props.type}.svg`;
    }
    return `/pieces/${(props.owner ?? 0) === 0 ? "w" : "b"}_${props.type}.svg`;
  };

  const tip = () => {
    const def = pieceDef(props.type);
    return `${def.name} — ${def.description ?? `moves like a ${def.name.toLowerCase()}`}`;
  };

  return (
    <span
      class={`pi ${props.class ?? ""}`}
      classList={{ exposed: props.exposed, draggable: props.draggable, dragging: props.dragging }}
      style={props.style}
      onPointerDown={props.onPointerDown}
      onMouseEnter={(e) => showTooltip(tip(), e.clientX, e.clientY, props.type)}
      onMouseMove={(e) => moveTooltip(e.clientX, e.clientY)}
      onMouseLeave={hideTooltip}
    >
      <img src={src()} alt={props.type} draggable={false} />
    </span>
  );
}
